import React, { useState, useRef, useEffect } from 'react';
import './Contact.css';
import { Link } from 'react-router-dom';

function Contact() {
  // Références pour les champs d'entrée
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);

  // Fonction pour gérer la soumission
  const handleSubmit = (event) => {
    event.preventDefault();

    // Récupérer les valeurs des champs
    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const phone = phoneRef.current.value;
    const subject = subjectRef.current.value;
    const userMessage = messageRef.current.value;

    // Créer le message formaté
    const whatsappMessage =
      `*Contact:*\n` +
      `- *Nom:* ${name}\n` +
      `- *Email:* ${email}\n` +
      `- *Téléphone:* ${phone}\n` +
      `- *Sujet:* ${subject}\n` +
      `- *Message:* ${userMessage}`;

    // Numéro de téléphone WhatsApp
    const phoneNumber = "212655760051"; // Remplacez par votre numéro
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    // Ouvrir le lien WhatsApp
    window.open(whatsappUrl, "_blank");
  };

  // Google Ads tracking script
  useEffect(() => {
    if (
      !document.querySelector(
        `script[src="https://www.googletagmanager.com/gtag/js?id=AW-11270497323"]`
      )
    ) {
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11270497323";
      script.async = true;
      document.head.appendChild(script);

      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-11270497323');
      `;
      document.head.appendChild(inlineScript);
    }

    const form = document.getElementById("contactForm");
    if (form) {
      const handleSubmit = (e) => {
        e.preventDefault(); // Empêcher le rechargement de la page
        if (typeof window.gtag === "function") {
          window.gtag("event", "conversion", {
            send_to: "AW-11270497323/Va3iCL-DsdMZEKvImP4p",
          });
        }
        form.submit(); // Optionnel : soumission après l'événement
      };

      form.addEventListener("submit", handleSubmit);
      return () => {
        form.removeEventListener("submit", handleSubmit);
      };
    }
  }, []);

  return (
    <div className='Contact'>
      <div className="banp">
        <div className="imge-containr">
          <img src="/imgcontact.jpg" alt="Instruments de ménage" className="banp-image" loading="lazy"/>
        </div>
        <div className="banp-content">
          <h1>Contactez-Nous <h5 class="banp-subtitle">Service nettoyage <span className='greater'>&gt;</span>Réservation</h5></h1>
        </div>
        
      </div>
    
      <div className="cotainer">
      <div className="ard">
        <div className="con-container">
          <img src="/email.png" alt="Mail" className="con" loading="lazy" />
        </div>
        <h3>Email 24/7</h3>
        <p>Biocleanersservices <br />@service.com</p>
      </div>
      <div className="ard">
        <div className="con-container">
          <img src="/location.png" alt="Location" className="con"loading="lazy" />
        </div>
        <h3>Localisation</h3>
        <p>Agadir(Siège) , Marrakech & Casablanca</p>
      </div>
      <div className="ard">
        <div className="con-container">
          <img src="/appel.png" alt="Phone" className="con" loading="lazy"/>
        </div>
        <h3>Contactez-Nous</h3>
        <p>Phone:+212 6 55 76 00 51<br /> </p>
        <p>Phone2: +212 681-965261</p>
      </div>
      <div className="ard">
        <div className="con-container">
          <img src="/days.png" alt="Calendar" className="con" loading="lazy"/>
        </div>
        <h3>Jours de travail</h3>
        <p>Lun au Sam -  08h00 à 18h00</p>
        <p>Dimanche - Off</p>
      </div>
    </div>
    <div class="containo">
        <div class="lef-content">
          <h6 className="sousttle">
            <img
              src="ballet.png"
              alt="Appeler"
              class="phon-icon"
              loading="lazy"
            />
            Contactez-nous
          </h6>
          <h1 class="tle">Heureux de répondre à toutes vos questions</h1>
          <p class="descriptio">
            Nous sélectionnons soigneusement tous nos nettoyeurs, vous pouvez
            donc être assuré que votre espace recevra un service de la plus
            haute qualité.
          </p>
          <div class="contac-info">
            <img
              src="/call.png"
              alt="Phone Icon"
              class="on"
              loading="lazy"
            />
            <span class="phone-number">+ (212) 6 55 76 00 51</span>
          </div>
          <button class="bok-demo-btn">
            <a href="/Book">Réservez une Démo Gratuite</a>
          </button>
        </div>
        <div class="rigt-content">
          <form
            className="contac-form"
            onSubmit={handleSubmit}
            id="contactForm"
          >
            <div className="for-group">
              <input type="text" ref={nameRef} placeholder="Votre Nom" required />
              <input ref={emailRef} type="email" placeholder="Votre Email" required />
            </div>
            <div className="for-group">
              <input ref={phoneRef} type="tel" placeholder="Votre Téléphone" required />
              <input ref={subjectRef} type="text" placeholder="Sujet" required />
            </div>
            <textarea
              ref={messageRef}
              placeholder="Message"
              rows="4"
              required
            ></textarea>
            <div className="checkbo-container">
              <input type="checkbox" id="save-info" />
              <label htmlFor="save-info">
                Enregistrer mon nom, mon e-mail et mon site web dans le
                navigateur pour mon prochain commentaire.
              </label>
            </div>
            <button type="submit" className="gcb">
              Get Cost Estimate
            </button>
          </form>
        </div>
      </div>
      
<div class="partner-container">
  <h2>Nos Partenaires</h2>
  <div className="partner-logos">
    <img src="/wafacash.png" alt="Super Clean Logo" className="partner-logo" loading="lazy"/>
    <img src="/akditale.png" alt="Carpet Cleaning Logo" className="partner-logo" loading="lazy"/>
    <img src="/palace.png" alt="Cristal Clean Logo" className="partner-logo" loading="lazy"/>
    <img src="/amalway.png" alt="Clear Cleaning Logo" className="partner-logo" loading="lazy"/>
    <img src="/dominiume.jpg" alt="Clear Glass Logo" className="partner-logo" loading="lazy"/>
  </div>
</div>
 
<div className="Contner">
  <div className="locations-section">
    {/* Lien qui redirige vers Google Maps */}
    <a
      href="https://www.google.com/maps/place/30%C2%B024'18.5%22N+9%C2%B003'27.4%22W"
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block' }} // Assure que le lien couvre la carte
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d220505.65770190198!2d-9.482451107180799!3d30.28264669106126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzDCsDI0JzE4LjUiTiA5wrAzMycyNy40Ilc!5e0!3m2!1sfr!2sma!4v1723663069281!5m2!1sfr!2sma"
        width="1500"
        height="350"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </a>
  </div>
</div>

<script src="//code.tidio.co/your-tidio-key.js" async></script>





</div>

  );
}

export default Contact;
